import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Ana', 'Juan', 'Sofía', 'Luis', 'Elena', 'Pedro', 'Lucía', 'Diego', 'Valentina', 'Mateo', 'Camila', 'Gabriel', 'Isabella'];
const LOCATIONS = [{
  city: 'Bogotá',
  country: 'Colombia'
}, {
  city: 'Lima',
  country: 'Perú'
}, {
  city: 'Santiago',
  country: 'Chile'
}, {
  city: 'Buenos Aires',
  country: 'Argentina'
}, {
  city: 'Ciudad de México',
  country: 'México'
}, {
  city: 'Quito',
  country: 'Ecuador'
}, {
  city: 'Medellín',
  country: 'Colombia'
}, {
  city: 'Guadalajara',
  country: 'México'
}, {
  city: 'Córdoba',
  country: 'Argentina'
}, {
  city: 'Montevideo',
  country: 'Uruguay'
}, {
  city: 'San José',
  country: 'Costa Rica'
}, {
  city: 'Asunción',
  country: 'Paraguay'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    country: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomLocation = LOCATIONS[Math.floor(Math.random() * LOCATIONS.length)];
      setData({
        name: randomName,
        city: randomLocation.city,
        country: randomLocation.country
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 5000);
    // Loop
    const interval = setInterval(() => {
      // Random interval between 8-12 seconds + 4 seconds display time
      const randomDelay = Math.floor(Math.random() * 4000) + 8000;
      setTimeout(showPopup, randomDelay);
    }, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-175">
      {isVisible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-4 left-4 z-40 bg-white rounded-lg shadow-xl p-4 max-w-xs border-l-4 border-green-600 flex items-center gap-3" data-id="element-176">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-177">
            <CheckCircle className="w-6 h-6 text-green-600" data-id="element-178" />
          </div>
          <div data-id="element-179">
            <p className="text-sm font-semibold text-gray-800" data-id="element-180">
              {data.name} de {data.city}, {data.country}
            </p>
            <p className="text-xs text-gray-500" data-id="element-181">
              acaba de comprar <b data-id="element-182">Música Escolar Lista</b>
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-183">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}